import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import posthog from 'posthog-js';
import OrzelKsiazkaIcon from '../../img/icons/orzel_ksiazka.png';

const FEEDBACK_QUESTIONS = [
    "Co Ci się podoba w Matematly?",
    "Co Ci przeszkadza w Matematly?",
    "Czego Ci brakuje w aplikacji?",
    "Co byś zmienił(a) w Matematly?",
    "Polecił(a)byś apkę znajomym? Dlaczego tak/nie?",
    "Co musiałoby się zmienić, żebyś chciał(a) korzystać dalej?",
];

const FeedbackPopup = ({ isOpen, onClose }) => {
    const [step, setStep] = useState('intro'); // 'intro' -> 'form' -> 'thanks'
    const [answer, setAnswer] = useState('');
    const [question] = useState(() =>
        FEEDBACK_QUESTIONS[Math.floor(Math.random() * FEEDBACK_QUESTIONS.length)]
    );

    useEffect(() => {
        if (isOpen) {
            posthog.capture('feedback_popup_viewed', { type: 'two_step_intro' });
            // Resetujemy stan, gdyby popup otwierał się ponownie w tej samej sesji
            setStep('intro');
            setAnswer('');
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handleAcceptIntro = () => {
        posthog.capture('feedback_permission_granted');
        setStep('form');
    };

    const handleSubmit = () => {
        posthog.capture('user_feedback', {
            question,
            answer: answer.trim(),
        });
        localStorage.setItem('feedback_prompt_done', Date.now().toString());
        setStep('thanks');
        setTimeout(() => onClose(), 1500);
    };

    const handleSkip = (skipContext) => {
        posthog.capture('user_feedback_skipped', { context: skipContext, question: step === 'form' ? question : null });
        localStorage.setItem('feedback_prompt_done', Date.now().toString());
        onClose();
    };

    return ReactDOM.createPortal(
        <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-[9998] p-4 backdrop-blur-sm animate-fade-in">
            <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 max-w-sm w-full text-center transform animate-swoosh-in border-4 border-white ring-4 ring-white/20">

                <div className="flex justify-center mb-4">
                    <img src={OrzelKsiazkaIcon} alt="Orzeł z książką" className="w-28 h-28" />
                </div>

                {step === 'thanks' && (
                    <>
                        <h2 className="text-2xl font-apotek tracking-wider text-[#233855] mb-3 uppercase font-bold">
                            Dzięki! 🔥
                        </h2>
                        <p className="text-gray-600 text-base leading-relaxed">
                            Czytam każdą odpowiedź. Twoja opinia naprawdę pomaga.
                        </p>
                    </>
                )}

                {step === 'intro' && (
                    <>
                        <h2 className="text-2xl font-apotek tracking-wider text-[#233855] mb-2 uppercase font-bold">
                            Masz sekundę? ⏱️
                        </h2>
                        <p className="text-gray-600 text-sm mb-6 leading-relaxed px-2">
                            Pracuję nad tym, żeby apka była lepsza. Pomożesz mi, odpowiadając na jedno pytanie?
                        </p>

                        <button
                            onClick={handleAcceptIntro}
                            className="w-full font-apotek tracking-widest uppercase text-sm text-white font-bold py-3 px-4 rounded-xl shadow-2xl transform transition-transform active:scale-95 bg-[#233855] hover:bg-[#1a2b42]"
                        >
                            Jasne, chętnie pomogę!
                        </button>

                        <button
                            onClick={() => handleSkip('intro_step')}
                            className="mt-4 w-full text-sm font-semibold text-gray-400 hover:text-gray-600 transition-colors uppercase tracking-wider py-2"
                        >
                            Nie teraz
                        </button>
                    </>
                )}

                {step === 'form' && (
                    <>
                        <p className="text-[#233855] mb-4 text-base font-bold leading-relaxed px-2">
                            {question}
                        </p>

                        <textarea
                            value={answer}
                            onChange={(e) => setAnswer(e.target.value)}
                            placeholder="Wystarczy jedno zdanie..."
                            className="w-full h-28 p-3 border border-gray-200 rounded-xl text-sm resize-none focus:outline-none focus:border-[#233855] focus:ring-1 focus:ring-[#233855] text-left mb-6 shadow-inner"
                            autoFocus
                        />

                        <button
                            onClick={handleSubmit}
                            disabled={!answer.trim()}
                            className="w-full font-apotek tracking-widest uppercase text-sm text-white font-bold py-3 px-4 rounded-xl shadow-2xl transform transition-transform active:scale-95 bg-[#233855] hover:bg-[#1a2b42] disabled:opacity-40 disabled:cursor-not-allowed"
                        >
                            Wyślij
                        </button>

                        <button
                            onClick={() => handleSkip('form_step')}
                            className="mt-4 w-full text-sm font-semibold text-gray-400 hover:text-gray-600 transition-colors uppercase tracking-wider py-2"
                        >
                            Jednak nie
                        </button>
                    </>
                )}
            </div>
        </div>,
        document.body
    );
};

export default FeedbackPopup;